import { render } from "./SendRateCard.vue?vue&type=template&id=ad68159a&scoped=true"
import script from "./SendRateCard.vue?vue&type=script&lang=js"
export * from "./SendRateCard.vue?vue&type=script&lang=js"

import "./SendRateCard.vue?vue&type=style&index=0&id=ad68159a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad68159a"]])

export default __exports__